import { cloneDeep } from "lodash-es"

import { BaseResponse } from "@/api/base"
import { FetchOrderTagsParams, IFilterCountRes, IOrderDefaultRes, ShipmentIdsRes } from "@/api/orders/type"
import { ExportHistoryPage } from "@/pages/Orders/components/ExportShipmentsControl/types"
import { QueryParamsType } from "@/pages/Orders/types"
import { UpdateStatusData } from "@/pages/Orders/UpdateStatus/types"
import baseRequest from "@/utils/baseRequest"
import request from "@/utils/request"

export default {
  /**
   * 获取更新状态列表
   * @param params
   */
  getUpdateStatusList(params: any) {
    interface RES extends BaseResponse {
      data: UpdateStatusData
    }

    return request.get<RES>("orders/update-status", { params })
  },

  /**
   * 获取 order 页面基本信息
   * @deprecated
   */
  orderDefaultMessage() {
    return request.get("orders/order-default")
  },

  /**
   * 获取 order 页面基本信息
   */
  getOrderDefaultMessage() {
    return baseRequest.get<IOrderDefaultRes>("v2/shipments/order-default?v=2")
  },

  /**
   * 根据 Shopify Order ID 查询加密后的 Shipment ID 列表
   */
  getShipmentIdsByOrderId(orderId: number | string) {
    return baseRequest.get<ShipmentIdsRes>("v2/shipments/ids", {
      params: { order_id: orderId },
    })
  },

  /**
   * 获取 order 页面基本信息
   */
  patchShipmentsException(status: boolean) {
    return baseRequest.patch("v2/shipments/first-exception", {
      "close_banner": status,
    })
  },

  /**
   * 获取 table 信息
   */
  getShipmentList(param: object) {
    return baseRequest.post("v2/shipments", param)
  },

  /**
   * 获取 table 信息
   */
  getAllOrderTags(params: FetchOrderTagsParams) {
    return baseRequest.get("v2/shipments/order-tags", { params })
  },

  /**
   * 添加/移除 order tags
   */
  manageOrderTags(params: object, action?: "REMOVE" | "ADD") {
    return baseRequest.post(`v2/shipments/manage-order-tags?action=${action}`, params)
  },

  /**
   * 导出条件获取
   */
  exportChesApi() {
    return baseRequest.post("v2/shipments/export-condition")
  },

  /**
   * 数据导出
   * @param param
   */
  exportDataApi(param: object) {
    return baseRequest.post("v2/shipments/export-data?_brand=parcelwill", param)
  },

  /**
   * 获取数据导出的字段
   */
  getExportFields() {
    return baseRequest.get("v2/shipments/export_fields")
  },

  /**
   * 更新数据导出的字段
   */
  setExportFields(data: {
    shipments_export_fields: {
      data: { "value": string, "selected": boolean }[]
    }
  }) {
    return baseRequest.post("v2/shipments/export_fields", data)
  },

  /**
   * 一级导航添加
   * @param param
   */
  firstNavAddNew(param: object) {
    return request.post("orders/nav-add", param)
  },

  /**
   * 一级导航删除
   * @param param
   */
  firstNavDelNew(param: object) {
    return request.post("orders/nav-delete", param)
  },

  // 添加或修改数据视图（传 old_view_name 为修改，不传为添加）
  saveShipmentView(view_name: string, filters: QueryParamsType, old_view_name?: string) {
    const params = new URLSearchParams({ view_name })

    if (old_view_name) params.set("old_view_name", old_view_name)
    return baseRequest.post(`v2/shipments/view?${params.toString()}`, { filters })
  },

  // 删除数据视图；视图名要编码，否则 UK 5+ 的 + 会被后端当成空格，& # % 等也会截断参数
  deleteShipmentView(view_name: string){
    return baseRequest.delete(`v2/shipments/view?${new URLSearchParams({ view_name }).toString()}`)
  },

  /**
   * 更新订单状态
   * @param params
   */
  setUpdateStatusList(params: any) {
    interface RES extends BaseResponse {
      data: UpdateStatusData
    }

    return request.post<RES>("orders/update-status", params)
  },

  /**
   * 邮件通知记录
   * @param param
   */
  mailRecords(param: object) {
    return request.post("orders/mail-records", param)
  },

  /**
   * 获取运输商列表
   */
  getCourier(){
    return baseRequest.get("/v2/trackings/couriers")
  },

  /**
   * 更新单号运输商
   * @param params
   */
  updateShipmentCourier(params: {
    nids: string[]
    courier_code: string
  }) {
    return baseRequest.post("/v2/shipments/couriers", params)
  },

  /**
   * 手动同步到PayPal
   * @param param
   * 如果全选，则传filters，如果不是全选则传入选中number_ids
   */
  syncPayPal(params: { number_ids?: string[], filters?: any }) {
    return baseRequest.post("v2/shipments/sync-paypal", params)
  },

  /**
   * 从 Shopify 重新拉取 order 信息并重跑流程
   * 如果全选，则传 filters，否则传 number_ids
   */
  refreshFromShopify(params: { number_ids?: string[], filters?: any }) {
    return baseRequest.post("v2/shipments/refresh-from-shopify", params)
  },

  setUpdateStatusListOld(params: any) {
    type RES = BaseResponse

    return request.post<RES>("old-api?hmac=a3094542008fe8b9275c54b996eb450f93f7803411490e0c817e90c883515c2f&host=bm93dGltZS1wcmV2aWV3Lm15c2hvcGlmeS5jb20vYWRtaW4&ids%5B%5D=4354178056266&locale=zh-CN&session=d64f7b9e6e05b9e2509efe9f54e0813fc3431efabac1817b3f1b7633b715772a&shop=trackingmore-5.myshopify.com&timestamp=1658193632", params)
  },

  /**
   * 根据参数，获取 number 表 id
   * @param params
   */
  queryFieldByParam(params: QueryParamsType) {
    return baseRequest.post("v2/shipments/query-field-by-param", params)
  },

  /**
   * 保存自动同步时间配置
   * @param param
   */
  syncTimeSet(param: object) {
    return request.post("orders/sync-time", param)
  },

  /**
   * 获取筛选项
   */
  getFilterItems(filterField: string, param: any) {
    const params = cloneDeep(param)

    if (params.status && Array.isArray(param.status)) {
      params.substatus = param.status.filter((item: string) => !isNaN(Number(item)))
      params.status = param.status.filter((item: string) => isNaN(Number(item)))
    }

    return baseRequest.post<IFilterCountRes>(`v2/shipments/field-count/${filterField}?v=2`, params)
  },

  /**
   * 获取筛选项
   */
  saveTableColumns(columns: object) {
    return baseRequest.post("v2/shipments/table-columns", { columns })
  },
  /**
   * 导出记录（游标分页，按导出时间倒序）
   */
  getExportHistory(params: { cursor?: string | null, limit?: number }) {
    // 非法 cursor 返回 422，由调用方丢弃游标重拉首页，不弹默认错误提示
    return baseRequest.get<{ data: ExportHistoryPage }>("v2/shipments/export-history", { params, useDefaultExceptionHandler: false })
  },

  /**
   * 换取导出文件下载链接（点击下载时调用，不缓存）
   * 文件过期（404）或 id 非法（422）时由 baseRequest 弹出后端 msg
   */
  getExportDownloadUrl(id: string) {
    return baseRequest.get<{ data: { download_url: string } }>("v2/shipments/export-history/download-url", { params: { id } })
  },

  /**
   * 更新导出邮箱
   */
  updateExportEmail(email: string) {
    return baseRequest.post("v2/shipments/export/rev_email", { "email": email })
  },
}
